import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import './hexagon.css'; // Your custom styles here
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { InstallPromptProvider } from "./utils/InstallPromptContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <InstallPromptProvider>
      <BrowserRouter>
     
        <App />
       
      </BrowserRouter>
    </InstallPromptProvider>
  </React.StrictMode>
);


reportWebVitals();
